module.exports = __webpack_public_path__ + "static/media/icon_menu.bf4d9e11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_menu.svg
// module id = 454
// module chunks = 0